module.exports = __webpack_public_path__ + "assets/images/GBP5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/GBP5.png
// module id = 1381
// module chunks = 1